<template>
  <div class="-slider-box -lightness-slider">
    <span>Lightness</span>
    <div class="-swatch">
      <div
        class="-handle"
        :class="{
          '-active': activePart === part.value,
        }"
        @click="setNewHsl(part.fValue)"
        v-for="(part, i) in swatchParts"
        :key="i"
        :style="{ background: part.background }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hsl: {
      type: Object,
      required: true,
    },

    standalone: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    swatchParts() {
      const parts = [100, 90, 70, 50, 30, 10, 0];
      const s = this.standalone;

      return parts.map((value) => {
        return {
          background: `hsla(${this.hsl.h},${
            s ? 100 : this.hsl.s * 100
          }%,${value}%,1)`,
          value,
          fValue: value / 100,
        };
      });
    },

    activePart() {
      const parts = this.swatchParts;
      const value = this.hsl.l * 100;
      const partsValues = parts.map((p) => p.value);
      const hasMatch = partsValues.includes(value);
      if (hasMatch) {
        return value;
      }
      // if no exact match, check for closest
      return _.find(partsValues, (p, i, arr) => {
        return value > p || value >= (arr[i + 1] || 0);
      });
    },
  },

  methods: {
    setNewHsl(newValue) {
      this.$emit('update-hsl', { l: newValue });
    },
  },
};
</script>
